/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetRealtorsRequest, TGetRealtorsModel, IMappers, TGetRealtorsResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetRealtorsResponse } from '../../entities/get_agents/GetRealtorsResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetRealtorsModel(parameters: IGetRealtorsRequest): TGetRealtorsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'agent-catalog-search',
    pathApi: '/v1/get-realtors/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetRealtorsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetRealtorsRequest;
}

export async function fetchGetRealtors<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetRealtorsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetRealtorsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetRealtorsModel(parameters),
    config,
  )) as FetchResponse<TGetRealtorsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRealtorsResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetRealtorsResponse>;
}
